import React, { Component } from "react";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../../config';
import { QuestionTypes } from "../../../../constants/QuestionTypes";
import {
  updateQuestionAnswers,
  getAnswers,
} from "../../../../services/formService";
import QAFooter from "./QAFooter";
import {isNullOrEmpty} from "../../../common/commonFuncs";

class TypeScale extends Component {
  state = {
    Question_ID: this.props.Question_ID,
    Question_Answers: [],
    lower_limit: 0,
    upper_limit: 0,
    step: 0,
    origStates: {
      lower_limit: 0,
      upper_limit: 0,
      step: 0
    }
  };

  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  async componentDidMount() {
    let { data: Question_Answers } = await getAnswers(this.state.Question_ID);
    if (Question_Answers.length > 0) {
      const lower_limit = parseInt(Question_Answers[0].Answer_Text);
      const step =
        parseFloat(Question_Answers[1].Answer_Text) -
        parseFloat(Question_Answers[0].Answer_Text);
      const upper_limit = parseInt(Question_Answers[Question_Answers.length - 1].Answer_Text);
      this.setState({
        lower_limit,
        upper_limit,
        step,
        origStates: {
          lower_limit: lower_limit,
          upper_limit: upper_limit,
          step: step
        }
      });
    }
    else {
      // disable re-map responses if this is a newly created widget that has not been saved yet
      this.props.setRemapResponses(false);
    }

    this.setState({ Question_Answers });
  }

  async handleSave() {
    const { lower_limit, upper_limit, step } = this.state;

    let Question_Answers = [];
    var i = lower_limit;
    while (i <= upper_limit) {
      Question_Answers.push({ Answer_ID: 0, Answer_Text: i });
      i += step;
    }

    const Question_ID = await this.props.onSave(Question_Answers);
    this.setState({
      Question_ID,
      origStates: {
        lower_limit: lower_limit,
        upper_limit: upper_limit,
        step: step
      }
    });


    // const { data } = await updateQuestionAnswers(Question_ID, Question_Answers);
    // if (data.includes("Error")) {
    //   toaster('error', data);
    // } else {
    //   toaster('error', 'Saved.');
    //   this.setState({ Question_Answers: data });
    // }
  }

  handleRemove() {
    this.props.onRemove();
  }

  handleChange = ({ currentTarget: input }) => {
    let value = isNullOrEmpty(input.value) ? 0: parseFloat(input.value);
    this.setState({ [input.name]: value });
  };

  /**
   * Allow re-mapping responses if lower limit, upper limit, step have NOT been changed
   * from what is currently saved.
   * @returns {boolean} True if allowed, False otherwise
   */
  verifyRemapResponses = () => {
    const origStates = this.state.origStates;
    return origStates.lower_limit === this.state.lower_limit &&
        origStates.upper_limit === this.state.upper_limit &&
        origStates.step === this.state.step;
  }

  render() {
    return (
      <React.Fragment>
        <div className="form-row">
          <div className="form-group col-md-4">
            <label htmlFor="lower_limit">Lower Limit</label>
            <input
              className="form-control"
              type="text"
              id="lower_limit"
              name="lower_limit"
              value={this.state.lower_limit}
              onChange={this.handleChange}
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="upper_limit">Upper Limit</label>
            <input
              className="form-control"
              type="text"
              id="upper_limit"
              name="upper_limit"
              value={this.state.upper_limit}
              onChange={this.handleChange}
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="step">Step</label>
            <input
              className="form-control"
              type="text"
              id="step"
              name="step"
              value={this.state.step}
              onChange={this.handleChange}
            />
          </div>
        </div>

        <QAFooter Widget_ID={this.props.Widget_ID}
                  handleSave={this.handleSave}
                  handleRemove={this.handleRemove}
                  showRemapResponses={true}
                  remapResponses={this.props.remapResponses}
                  setRemapResponses={this.props.setRemapResponses}
                  verifyRemapResponses={this.verifyRemapResponses}/>
      </React.Fragment>
    );
  }
}

export default TypeScale;
